import type { Tone } from './Metric.tsx'

const TONE_BG: Record<Tone, string> = {
  neutral: 'bg-line-strong',
  accent: 'bg-accent',
  ok: 'bg-ok',
  warn: 'bg-warn',
  crit: 'bg-crit',
}

/**
 * A 6px square status marker.
 *
 * Square rather than round on purpose — it reads as an indicator lamp on a
 * console instead of a bullet point, and it is the only non-text carrier of
 * status colour in the app. `aria-hidden` because the colour always sits next
 * to a text label that says the same thing; colour is never the sole channel.
 */
export function StatusDot({ tone, className = '' }: { tone: Tone; className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={`inline-block size-1.5 shrink-0 rounded-xs ${TONE_BG[tone]} ${className}`}
    />
  )
}
